import React, { FC, useCallback, useEffect, useState } from "react";
import styled from "styled-components";

import { Button, Icon } from "../../../../../../components/atoms";
import { SelectBox } from "../../../../../../components/molecules/SelectBox/SelectBox";

import { BankCard } from "../../../../../../models/BankCard.model";
import { InputWithWildCard } from "../../../../../../components/molecules/InputWithWildCard/InputWithWildCard";
import PreDefinedBalances from "./components/PreDefinedBalances";
import buildClassName from "../../../../../../utils/buildClassName";
import { GetUserWallet } from "../../../../../../store/actions/user/UserActions";
import { useDispatch, useSelector } from "react-redux";
import UserBalanceAndRefresh from "./components/UserBalanceAndRefresh";
import AddCardDialog from "./components/AddCardDialog";
import UseShowKyc from "../../../../../../components/custom-hook/UseShowKyc";
import { RootStore } from "../../../../../../store/Store";
import { FormError } from "../../../../../otcTether/types/FormError";
import { CARDS } from "../../../../../../api-calls";
import { IRT_IPG_INITIALIZE } from "../../../../../../api-calls";
import {
  SetCoinWithdrawPendingForCharge,
  SetRedirectURL,
} from "../../../../../../store/actions/coinWithdraw/CoinWithdrawActions";
import { useTranslation } from "react-i18next";

const DepositIrtWrapper = styled.div<{ isMobileScreen: boolean }>`
  display: flex;
  overflow: hidden;
  //overflow-y: auto;
  height: 0;
  flex-flow: row wrap;
  justify-content: center;
  background-color: ${(theme) => theme.theme.bgColor3};
  align-content: space-around;
  border-radius: 8px;
  &.active {
    position: ${(p) => (p.isMobileScreen ? "fixed" : "absolute")};
    right: 0;
    top: 0;
    width: 100%;
    height: ${(p) => (p.isMobileScreen ? "calc(100% - 50px)" : "586px")};
    padding: ${(p) => (p.isMobileScreen ? "24px 20px" : "0 15px")};
    z-index: 2;
  }
`;

const DepositIrtHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: ${(theme) => theme.theme.Light1};
  font-size: 16px;
  width: 100%;
  .go-back {
    cursor: pointer;
  }
  span {
    display: block;
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

const DepositIrtBalance = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  color: ${(theme) => theme.theme.Light1};
  border-bottom: 2px dashed ${(theme) => theme.theme.bgPrimaryMedium};
  padding-bottom: 20px;
  min-height: 80px;
  .balance-row {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .refresh-balance-row {
      display: flex;
      justify-content: space-between;
      .refresh-balance {
        cursor: pointer;
        display: inline-block;
      }
    }

    .title {
      font-size: 12px;
      color: ${(theme) => theme.theme.etDark2};
    }
    .max-balance {
      font-size: 12px;
      color: ${(theme) => theme.theme.Light1};
    }
  }
`;

const DepositIrtInputs = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;

  .input-caption-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: ${(theme) => theme.theme.white};
    #deposit-title {
      font-size: 14px;
    }
    #add-bank-card {
      font-size: 12px;
      color: ${(theme) => theme.theme.bgText};
      border-bottom: 1px solid ${(theme) => theme.theme.bgButton};
      cursor: pointer;
    }
  }
`;

const UserCardsSelector = styled.div`
  display: flex;
  width: 100%;
  div {
    width: 100%;
  }
`;

const ToBalanceUserInput = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  .input-caption-row {
    width: 100%;
    display: flex;
    margin-bottom: 12px;
    justify-content: space-between;
    color: ${(theme) => theme.theme.Light1};
    #deposit-title-balance {
      font-size: 14px;
    }
  }
`;

const HelpBlock = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .help-text {
    margin-right: 16px;
    color: ${(theme: any) => theme.theme.etRed};
    span {
      font-size: 14px;
      display: block;
      text-align: right;
      &:not(:first-child) {
        margin-right: 5px;
      }
    }
  }
`;

type OwnProps = {
  showDeposit: boolean;
  onClose: () => void;
  isMobileScreen: boolean;
};

const DepositIrt: FC<OwnProps> = ({ showDeposit, onClose, isMobileScreen }) => {
  const dispatch = useDispatch();

  const [showKycModal, setShowKycModal] = useState(false);

  const [isUserInput, setIsUserInput] = useState(false);

  const [showAddCardDialog, setShowAddCardDialog] = useState(false);

  const [payerCardNumber, setPayerCardNumber] = useState("");

  const [boxOptions, setBoxOptions] = useState([]);

  const [hasNoCard, setHasNoCard] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [balanceValue, setBalanceValue] = useState<any>("");

  const [defaultKye, setDefaultKye] = useState<any>(false);

  const { t, i18n } = useTranslation();
  const lng = i18n.language;

  const [formError, setFormError] = useState<FormError>({
    hasError: false,
    message: "",
  });

  let UserState = useSelector((state: RootStore) => state.user);
  let coinWithdrawState = useSelector((state: RootStore) => state.coinWithdraw);

  const handleSelectChange = (item: any) => {
    setPayerCardNumber(item.key);
  };

  const getUserCards = useCallback(async () => {
    await CARDS().then(
      (res) => {
        let list: any = [];
        res.data.data.map((item: BankCard, index: number) => {
          if (index === 0) {
            handleConfirmedCard(item);
          }
          list.push({
            key: item.cardNumber,
            value: item.cardNumber,
            logo: item.logo,
            extraText: item.bankName,
          });
        });
        if (!list.length) {
          setHasNoCard(true);
        }
        setBoxOptions(list);
      },
      (error) => {}
    );
  }, []);

  useEffect(() => {
    getUserCards();
  }, [getUserCards]);

  const addBalance = async () => {
    if (UserState.user?.limitationName === "LEVEL_1") {
      setShowKycModal(true);
      return;
    }
    if (!payerCardNumber) {
      setFormError({
        hasError: true,
        message: t("deposit.err"),
      });
      return;
    }
    let value = balanceValue;
    if (typeof value === "string") {
      value = balanceValue.replace(",", "");
    }
    setIsLoading(true);

    // const redirectUrl = `${window.location.origin}/app${window.location.pathname}`;
    await IRT_IPG_INITIALIZE({
      amount: value / 10,
      payerCardNumber,
      // redirectUrl: redirectUrl,
      redirectUrl: coinWithdrawState.redirectUrl || undefined,
    }).then(
      (res) => {
        setIsLoading(false);
        dispatch(GetUserWallet());
        if (coinWithdrawState?.redirectUrl) {
          dispatch(SetRedirectURL(undefined));
          dispatch(SetCoinWithdrawPendingForCharge(true));
        }
        window.location.href = res.data.data;
      },
      (error) => {
        setIsLoading(false);
        setFormError({
          hasError: true,
          message: error.data.message,
        });
      }
    );
  };

  const handleOpenAddCardDialog = () => {
    if (UserState.user?.limitationName === "LEVEL_1") {
      setShowKycModal(true);
      return;
    }
    setShowAddCardDialog(true);
  };

  const handleBalanceChange = (data: any) => {
    setFormError({
      hasError: false,
      message: "",
    });

    setIsUserInput(true);

    setBalanceValue(data.value);
  };

  const handleAddCardDialogClosed = () => {
    setShowAddCardDialog(false);
    getUserCards();
  };

  const handleSelectedBalance = (balance: any) => {
    setBalanceValue(balance);

    setIsUserInput(false);

    setFormError({
      hasError: false,
      message: "",
    });
  };

  const handleConfirmedCard = (card: BankCard | undefined) => {
    if (typeof card !== "undefined") {
      setPayerCardNumber(card.cardNumber);
      setDefaultKye(card.cardNumber);
    }
  };

  return (
    <DepositIrtWrapper
      isMobileScreen={isMobileScreen}
      className={buildClassName(showDeposit && "active")}
    >
      <DepositIrtHeader>
        <div className="go-back" onClick={onClose}>
          {lng === "fa" ? (
            <Icon name="boxArrowWhiteRight" width="20px" height="20px" />
          ) : (
            <Icon name="boxArrowWhiteRightEn" width="20px" height="20px" />
          )}
        </div>
        <span>{t("deposit.title")}</span>
      </DepositIrtHeader>
      <DepositIrtBalance>
        <div className="balance-row">
          <UserBalanceAndRefresh />
        </div>
        <div className="balance-row">
          <span className="title">{t("deposit.limit")}</span>
          <span className="max-balance">{t("deposit.limitNum")}</span>
        </div>
      </DepositIrtBalance>
      <DepositIrtInputs>
        <div className="input-caption-row">
          <span id="deposit-title">{t("deposit.bankAcc")}</span>
          <span id="add-bank-card" onClick={handleOpenAddCardDialog}>
            {t("deposit.addBankAcc")}
          </span>
        </div>
      </DepositIrtInputs>
      <UserCardsSelector>
        {boxOptions.length !== 0 && (
          <SelectBox
            onChange={handleSelectChange}
            bgColor="bgButton"
            defaultKey={defaultKye}
            isWithdraw
            boxOptions={boxOptions}
          />
        )}
      </UserCardsSelector>
      <ToBalanceUserInput>
        <div className="input-caption-row">
          <span id="deposit-title-balance">{t("deposit.increaseAmount")}</span>
        </div>
        <InputWithWildCard
          hasError={formError.hasError}
          listenToChange
          wild={t("deposit.irr")}
          name={"IRT"}
          wildColor={"white"}
          maskType={"MASKED"}
          // direction={"rtl"}
          defaultValue={balanceValue}
          placeholder={t("deposit.inputPlaceholder")}
          type={"tel"}
          bgColor={"bgButton"}
          handleOnChange={(data) => handleBalanceChange(data)}
        />
        {formError.hasError && (
          <HelpBlock>
            <Icon name="helpInfo" width="15px" height="15px" />
            <div className="help-text">
              <span>{formError.message}</span>
            </div>
          </HelpBlock>
        )}
      </ToBalanceUserInput>
      <PreDefinedBalances
        isUserInputActive={isUserInput}
        onSelectBalance={handleSelectedBalance}
      />
      <Button
        id="222"
        customStyle={"margin-top: 16px"}
        color={"white"}
        isLoading={isLoading}
        width="100%"
        onClick={addBalance}
        primary={true}
        backgroundColor={"bgPrimary"}
        disabled={isLoading || !payerCardNumber || formError.hasError}
        text={t("deposit.btnRedirect")}
      />
      <AddCardDialog
        onConfirmedCard={handleConfirmedCard}
        onCloseDialog={handleAddCardDialogClosed}
        showDialog={showAddCardDialog}
      />
      <UseShowKyc show={showKycModal} onClose={() => setShowKycModal(false)} />
    </DepositIrtWrapper>
  );
};

export default DepositIrt;
